'use client';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import Icon from '@/components/ui/AppIcon';

interface NewsletterForm {
  email: string;
}

export default function NewsletterSection() {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, reset, formState: { errors } } = useForm<NewsletterForm>();

  const onSubmit = async (data: NewsletterForm) => {
    setLoading(true);
    // BACKEND: POST /api/newsletter/subscribe with data.email
    await new Promise(r => setTimeout(r, 1200));
    setLoading(false);
    toast.success('You are subscribed! Check your inbox for a welcome email.');
    reset();
  };

  return (
    <section className="py-16 bg-white border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 gradient-purple rounded-2xl mb-4 shadow-purple">
            <Icon name="EnvelopeIcon" size={24} className="text-white" />
          </div>
          <h2 className="text-3xl font-extrabold text-foreground mb-3">
            Stay ahead of the <span className="text-gradient">curve</span>
          </h2>
          <p className="text-muted-foreground mb-6">
            Get weekly updates on new courses, live class schedules, WAEC prep tips, and exclusive discounts delivered to your inbox.
          </p>

          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <div className="flex-1">
              <input
                type="email"
                placeholder="your@email.com"
                {...register('email', {
                  required: 'Email is required',
                  pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Enter a valid email' },
                })}
                className="w-full px-4 py-3 rounded-xl border border-border bg-background text-sm focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all"
              />
              {errors.email && <p className="text-xs text-danger mt-1 text-left">{errors.email.message}</p>}
            </div>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-3 gradient-purple text-white rounded-xl font-semibold text-sm hover:opacity-90 transition-all active:scale-95 disabled:opacity-60 flex items-center gap-2 justify-center min-w-[140px]"
            >
              {loading ? (
                <>
                  <Icon name="ArrowPathIcon" size={16} className="animate-spin" />
                  Subscribing...
                </>
              ) : (
                'Subscribe Free'
              )}
            </button>
          </form>
          <p className="text-xs text-muted-foreground mt-3">No spam. Unsubscribe anytime. 12,400+ subscribers.</p>
        </div>
      </div>
    </section>
  );
}